import { render, staticRenderFns } from "./AreYouSure.vue?vue&type=template&id=f6f36ce2&"
import script from "./AreYouSure.vue?vue&type=script&lang=js&"
export * from "./AreYouSure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports